import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enMenu from './locales/en/menu.json';
import enSearch from './locales/en/search.json';
import enCompanies from './locales/en/companies.json';
import enPerson from './locales/en/person.json';
import enProjects from './locales/en/projects.json';
import enNetwork from './locales/en/network.json';
import enAlumni from './locales/en/alumni.json';
import enCtuCompanies from './locales/en/ctuCompanies.json';
import enAdmin from './locales/en/admin.json';
import enPrivacy from './locales/en/privacy.json';
import enAbout from './locales/en/about.json';

import csCommon from './locales/cs/common.json';
import csDashboard from './locales/cs/dashboard.json';
import csMenu from './locales/cs/menu.json';
import csSearch from './locales/cs/search.json';
import csCompanies from './locales/cs/companies.json';
import csPerson from './locales/cs/person.json';
import csProjects from './locales/cs/projects.json';
import csNetwork from './locales/cs/network.json';
import csAlumni from './locales/cs/alumni.json';
import csCtuCompanies from './locales/cs/ctuCompanies.json';
import csAdmin from './locales/cs/admin.json';
import csPrivacy from './locales/cs/privacy.json';
import csAbout from './locales/cs/about.json';

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    menu: enMenu,
    search: enSearch,
    companies: enCompanies,
    person: enPerson,
    projects: enProjects,
    network: enNetwork,
    alumni: enAlumni,
    ctuCompanies: enCtuCompanies,
    admin: enAdmin,
    privacy: enPrivacy,
    about: enAbout,
  },
  cs: {
    common: csCommon,
    dashboard: csDashboard,
    menu: csMenu,
    search: csSearch,
    companies: csCompanies,
    person: csPerson,
    projects: csProjects,
    network: csNetwork,
    alumni: csAlumni,
    ctuCompanies: csCtuCompanies,
    admin: csAdmin,
    privacy: csPrivacy,
    about: csAbout,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'cs',
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'dashboard', 'menu', 'search', 'companies', 'person', 'projects', 'network', 'alumni', 'ctuCompanies', 'admin', 'privacy', 'about'],

    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
